import { render, staticRenderFns } from "./holoData.vue?vue&type=template&id=1c57d486&scoped=true&"
import script from "./holoData.vue?vue&type=script&lang=js&"
export * from "./holoData.vue?vue&type=script&lang=js&"
import style0 from "./less/holoData.less?vue&type=style&index=0&id=1c57d486&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57d486",
  null
  
)

export default component.exports